import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322b11ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "text-xl font-bold grid-content" }
const _hoisted_3 = { class: "flex mb-3 font-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex mr-3" }, "Agency Edit Dropship Catalog", -1))
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Out of stock ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-history el-icon--left" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  History ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  Ask price ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  Confirm price ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-level-up-alt" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("  Publish ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1))
const _hoisted_18 = { class: "px-5 pt-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Variants")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mockup")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center ml-3 text-gray-600 w-35" }, " Processing time (days) ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Production")
], -1))
const _hoisted_23 = { class: "" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Shipping")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center ml-3 text-gray-600 w-35" }, " Shipping time (days) ", -1))
const _hoisted_26 = { class: "" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Material")
], -1))
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("  Delete ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }),
  /*#__PURE__*/_createTextVNode("  Save ")
], -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete catalog ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_37 = { class: "dialog-footer" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode("  Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_DropVariants = _resolveComponent("DropVariants")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_HistoryChangeDialog = _resolveComponent("HistoryChangeDialog")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_row, { class: "p-2.5 w-full create-catalog" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { md: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_el_divider, { direction: "vertical" }),
                      _createVNode(_component_el_tag, {
                        type: _ctx.getPublishStatusTagColor(_ctx.catalog.publishStatus),
                        class: "mr-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getPublishStatusName(_ctx.catalog.publishStatus)), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]),
                      (_ctx.catalog.outOfStock)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.historyDialogToggle(_ctx.catalog._id)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.updatePublistStatusCatalogs(
                  _ctx.catalog._id,
                  _ctx.CATALOG_PUBLISH_STATUS.ASK_PRICE
                )
              ))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (
                _ctx.updatePublistStatusCatalogs(
                  _ctx.catalog._id,
                  _ctx.CATALOG_PUBLISH_STATUS.CONFIRM_PRICE
                )
              ))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.updatePublistStatusCatalogs(
                  _ctx.catalog._id,
                  _ctx.CATALOG_PUBLISH_STATUS.PUBLISHED
                )
              ))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.updateCatalog
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_directive_loading, _ctx.isLoading]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { class: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_17
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_el_form, {
                                  model: _ctx.catalog,
                                  rules: _ctx.rulesCatalog,
                                  ref: "catalogFormUpdate",
                                  "label-width": "15%"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "name",
                                      label: "Name",
                                      required: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.catalog.name,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.catalog.name) = $event)),
                                          placeholder: "Enter name"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "category",
                                      label: "Category"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          class: "w-full",
                                          multiple: "",
                                          modelValue: _ctx.catalog.categories,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.catalog.categories) = $event)),
                                          placeholder: "Select category"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item._id,
                                                label: item.title,
                                                value: item._id,
                                                size: 25
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "tags",
                                      label: "Tags"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.catalog.tags,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.catalog.tags) = $event)),
                                          multiple: "",
                                          filterable: "",
                                          class: "w-full",
                                          "allow-create": "",
                                          "default-first-option": "",
                                          "reserve-keyword": false,
                                          placeholder: "Enter tags"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item._id,
                                                label: item.name,
                                                value: item._id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "niches",
                                      label: "Niches"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.catalog.niches,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.catalog.niches) = $event)),
                                          multiple: "",
                                          class: "w-full",
                                          filterable: "",
                                          "allow-create": "",
                                          "default-first-option": "",
                                          "reserve-keyword": false,
                                          placeholder: "Enter niches"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.niches, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "publishStatus",
                                      label: "Publish status"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.catalog.publishStatus,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.catalog.publishStatus) = $event)),
                                          placeholder: "Select Publish status"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PUBLISH_STATUS_ARR, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.value,
                                                label: item.label,
                                                value: item.value
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_tag, {
                                                    type: _ctx.getPublishStatusTagColor(item.value)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.getPublishStatusName(item.value)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["type"])
                                                ]),
                                                _: 2
                                              }, 1032, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "outOfStock",
                                      label: "Stock status"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.catalog.outOfStock,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.catalog.outOfStock) = $event)),
                                          placeholder: "Select out of stock"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              key: 0,
                                              label: "In stock",
                                              value: false
                                            }),
                                            _createVNode(_component_el_option, {
                                              key: 1,
                                              label: "Out of stock",
                                              value: true
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "isTrademark",
                                      label: "Trademark"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.catalog.isTrademark,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.catalog.isTrademark) = $event)),
                                          placeholder: "Select trademark status"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              key: 0,
                                              label: "Not Trademark",
                                              value: false
                                            }),
                                            _createVNode(_component_el_option, {
                                              key: 0,
                                              label: "Trademark",
                                              value: true
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "productCode",
                                      label: "Product code",
                                      required: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.catalog.productCode,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.catalog.productCode) = $event)),
                                          placeholder: "Product code"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "brand",
                                      label: "Brand"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.catalog.brand,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.catalog.brand) = $event)),
                                          placeholder: "Brand"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "brandCode",
                                      label: "Brand code"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.catalog.brandCode,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.catalog.brandCode) = $event)),
                                          placeholder: "Brand code"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_tabs, {
                                      modelValue: _ctx.activeName,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.activeName) = $event)),
                                      class: "demo-tabs",
                                      onTabClick: _ctx.handleClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Overview",
                                          name: "description",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.description,
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.catalog.description) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Feature",
                                          name: "description2",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.description2,
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.catalog.description2) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "Size guide",
                                          name: "sizeGuide",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.sizeGuide,
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.catalog.sizeGuide) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "About information",
                                          name: "aboutDescription",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.aboutDescription,
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.catalog.aboutDescription) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: `Return & Refund Information`,
                                          name: "returnDescription",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.returnDescription,
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.catalog.returnDescription) = $event))
                                                  }, null, 8, ["modelValue"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onTabClick"])
                                  ]),
                                  _: 1
                                }, 8, ["model", "rules"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "mt-3" }, {
                            header: _withCtx(() => [
                              _hoisted_19
                            ]),
                            default: _withCtx(() => [
                              (!_ctx.loadingCountries)
                                ? (_openBlock(), _createBlock(_component_DropVariants, {
                                    key: 0,
                                    isAcceptColor: 
                  _ctx.isSubmit &&
                  _ctx.catalog &&
                  _ctx.catalog.colors &&
                  _ctx.catalog.colors.length === 0
                    ? true
                    : false
                ,
                                    isAcceptSize: 
                  _ctx.isSubmit &&
                  _ctx.catalog &&
                  _ctx.catalog.sizes &&
                  _ctx.catalog.sizes.length === 0
                    ? true
                    : false
                ,
                                    onChangeCostBy: _ctx.changeCostBy,
                                    onCallback: _ctx.callbackVariant,
                                    onCallbackOptionName: _ctx.callbackChangeOptionName,
                                    onOnAfterUpdateVariant: _ctx.onAfterUpdateVariant,
                                    colors: _ctx.catalog.colors,
                                    sizes: _ctx.catalog.sizes,
                                    costBy: _ctx.costBy,
                                    values: _ctx.catalog.variants,
                                    designs: _ctx.catalog.designs,
                                    productCode: _ctx.catalog.productCode,
                                    countries: _ctx.countries,
                                    displaySizeName: _ctx.catalog.displaySizeName,
                                    displayColorName: _ctx.catalog.displayColorName,
                                    displaySupplierPrice: 
                  _ctx.catalog?.publishStatus != _ctx.CATALOG_PUBLISH_STATUS.DRAFT
                ,
                                    typeAction: "edit"
                                  }, null, 8, ["isAcceptColor", "isAcceptSize", "onChangeCostBy", "onCallback", "onCallbackOptionName", "onOnAfterUpdateVariant", "colors", "sizes", "costBy", "values", "designs", "productCode", "countries", "displaySizeName", "displayColorName", "displaySupplierPrice"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                md: 6,
                class: "pl-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_20
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_UploadImage, {
                          accept: `image/*`,
                          multiple: true,
                          title: ``,
                          setData: _ctx.catalog,
                          data: _ctx.catalog.mockupGallery,
                          onCallback: _ctx.callbackMockup
                        }, null, 8, ["setData", "data", "onCallback"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_22
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createVNode(_component_el_input, {
                            class: "m-2 w-50",
                            modelValue: _ctx.catalog.processingTime,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.catalog.processingTime) = $event)),
                            modelModifiers: { number: true },
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.catalog.production,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.catalog.production) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_24
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createVNode(_component_el_input, {
                            class: "m-2 w-50",
                            modelValue: _ctx.catalog.shippingTime,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.catalog.shippingTime) = $event)),
                            modelModifiers: { number: true },
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Editor, {
                          modelValue: _ctx.catalog.shipping,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.catalog.shipping) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_27
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Editor, {
                        modelValue: _ctx.catalog.material,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.catalog.material) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: "mt-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, {
                        onClick: _ctx.deleteCatalog,
                        type: "danger",
                        hidden: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          }),
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, { onClick: _ctx.discard }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _hoisted_31
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.updateCatalog
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32,
                          _hoisted_33
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.dialog,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dialog) = $event)),
                width: "40%"
              }, {
                title: _withCtx(() => [
                  _hoisted_34
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_el_button, { onClick: _ctx.cancelDelete }, {
                      default: _withCtx(() => [
                        _hoisted_38,
                        _hoisted_39
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.confirmDelete
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40,
                        _hoisted_41
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_35,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.catalog.name), 1),
                    _hoisted_36
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_HistoryChangeDialog, { ref: "historyChangeDialog" }, null, 512)
    ]),
    _: 1
  }, 16))
}